import { Meta } from '@/components/common';
import { Notifications } from '@/components/features/notifications';
import { Container } from '@/components/layout';

/** The signed-in user's notifications. The shell's header carries the title. */
export function NotificationsPage() {
  return (
    <>
      <Meta title="Notifications" />

      <Container>
        <Notifications />
      </Container>
    </>
  );
}
